//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'áááááá á_ááááá áááá_ááá á¢á_ááá ááá_áááá¡á_ááááá¡á_ááááá¡á_ááááá¡á¢á_á¡áá¥á¢ááááá á_áá¥á¢ááááá á_ááááááá á_áááááááá á'.split(
            '_'
        ),
        monthsShort: 'ááá_ááá_ááá _ááá _ááá_ááá_ááá_ááá_á¡áá¥_áá¥á¢_ááá_ááá'.split('_'),
        weekdays: {
            standalone:
                'áááá á_áá á¨ááááá_á¡ááá¨ááááá_ááá®á¨ááááá_á®á£áá¨ááááá_ááá áá¡áááá_á¨ááááá'.split(
                    '_'
                ),
            format: 'áááá áá¡_áá á¨ááááá¡_á¡ááá¨ááááá¡_ááá®á¨ááááá¡_á®á£áá¨ááááá¡_ááá áá¡áááá¡_á¨ááááá¡'.split(
                '_'
            ),
            isFormat: /(á¬ááá|á¨ááááá)/,
        },
        weekdaysShort: 'ááá_áá á¨_á¡áá_ááá®_á®á£á_ááá _á¨áá'.split('_'),
        weekdaysMin: 'áá_áá _á¡á_áá_á®á£_áá_á¨á'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[áá¦áá¡] LT[-áá]',
            nextDay: '[á®ááá] LT[-áá]',
            lastDay: '[áá£á¨áá] LT[-áá]',
            nextWeek: '[á¨ááááá] dddd LT[-áá]',
            lastWeek: '[á¬ááá] dddd LT-áá',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(á¬áá|á¬á£á|á¡ááá|á¬áá|áá¦|áá)(á|á)/,
                    function ($0, $1, $2) {
                        return $2 === 'á' ? $1 + 'á¨á' : $1 + $2 + 'á¨á';
                    }
                );
            },
            past: function (s) {
                if (/(á¬ááá|á¬á£áá|á¡áááá|áá¦á|ááá)/.test(s)) {
                    return s.replace(/(á|á)$/, 'áá¡ á¬áá');
                }
                if (/á¬ááá/.test(s)) {
                    return s.replace(/á¬ááá$/, 'á¬ááá¡ á¬áá');
                }
                return s;
            },
            s: 'á áááááááá á¬ááá',
            ss: '%d á¬ááá',
            m: 'á¬á£áá',
            mm: '%d á¬á£áá',
            h: 'á¡áááá',
            hh: '%d á¡áááá',
            d: 'áá¦á',
            dd: '%d áá¦á',
            M: 'ááá',
            MM: '%d ááá',
            y: 'á¬ááá',
            yy: '%d á¬ááá',
        },
        dayOfMonthOrdinalParse: /0|1-áá|áá-\d{1,2}|\d{1,2}-á/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-áá';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'áá-' + number;
            }
            return number + '-á';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));
